import buildFacetQueryString from "../buildFacetQueryString";
import buildPartnerAreaQueryString from "../buildPartnerAreaQueryString";

const constructQueryString = ({ facets, partnerAreas, keyword, order, page }) => {
    let qsa = '?spa=true';
    let facetsQsa = '';
    let partnerAreasQsa = '';

    facets.forEach(facet => {
        facetsQsa += buildFacetQueryString(facet);
    });

    partnerAreas.forEach(partnerArea => {
        partnerAreasQsa += buildPartnerAreaQueryString(partnerArea);
    });

    if (order) qsa += `&sort=${order}`;
    if (keyword) qsa += `&q=${keyword}`;
    if (page) qsa += `&page=${page}`;

    qsa += facetsQsa + partnerAreasQsa;
    return qsa;
};

export default constructQueryString;
